import gql from 'graphql-tag'

const QUERY_GET_PRODUCT = gql`
  query getProduct($merchant: String!, $slug: String!, $storeSlug: String!) {
    products(
      where: {
        merchant: { slug: { _eq: $merchant } }
        slug: { _eq: $slug }
        archived_at: { _is_null: true }
      }
      limit: 1
    ) {
      id
      name
      description
      category {
        id
        name
        slug
      }
      default_vat
      slug
      type
      default_variant_id
      options
      attributes
      variants: product_variants(
        where: {
          store_variants: {
            published_at: { _is_null: false }
            in_stock: { _eq: true }
          }
        }
      ) {
        default_variant
        id
        name
        sku
        description
        attributes
        options
        image
        price
        published
        restrictions
        limit
        vat
        store_variants(
          where: {
            store: { slug: { _eq: $storeSlug } }
            product_variant: { product: { slug: { _eq: $slug } } }
          }
        ) {
          in_stock
          store_id
          stock_count
          stock_type
          stock_sold
          published_at
          product_variant {
            id
          }
        }
        additionalImages: additional_images {
          id
        }
        source: product {
          slug
          category_id
          category {
            id
            name
            slug
          }
        }
      }
      modifier_group_arrangement
      product_modifiers: product_modifier_groups {
        modifier_group {
          id
          name
          minimum
          minimum_enabled
          maximum
          maximum_enabled
          modifier_arrangement
          modifier_assocs: modifier_group_modifiers(
            where: {
              modifier: {
                store_modifiers: {
                  published_at: { _is_null: false }
                  store: { slug: { _eq: $storeSlug } }
                }
              }
            }
          ) {
            id
            modifier {
              price
              id
              name
              vat
              sku
              store_modifiers(where: { store: { slug: { _eq: $storeSlug } } }) {
                in_stock
              }
            }
          }
        }
      }
    }
  }
`

const QUERY_GET_PREORDER_PRODUCT = gql`
  query getProduct($merchant: String!, $slug: String!, $storeSlug: String!) {
    products(
      where: {
        merchant: { slug: { _eq: $merchant } }
        slug: { _eq: $slug }
        archived_at: { _is_null: true }
      }
      limit: 1
    ) {
      id
      name
      description
      category {
        id
        name
        slug
      }
      default_vat
      slug
      type
      default_variant_id
      options
      attributes
      variants: product_variants(
        where: {
          store_variants: {
            published_at: { _is_null: false }
            in_stock: { _eq: true }
          }
        }
      ) {
        default_variant
        id
        name
        sku
        description
        attributes
        options
        image
        price
        published
        restrictions
        limit
        vat
        store_variants(
          where: { product_variant: { product: { slug: { _eq: $slug } } } }
        ) {
          in_stock
          store_id
          stock_count
          stock_type
          stock_sold
          published_at
          product_variant {
            id
          }
        }
        additionalImages: additional_images {
          id
        }
        source: product {
          slug
          category_id
          category {
            id
            name
            slug
          }
        }
      }
      modifier_group_arrangement
      product_modifiers: product_modifier_groups {
        modifier_group {
          id
          name
          minimum
          minimum_enabled
          maximum
          maximum_enabled
          modifier_arrangement
          modifier_assocs: modifier_group_modifiers(
            where: {
              modifier: {
                store_modifiers: {
                  published_at: { _is_null: false }
                  store: { merchant: { slug: { _eq: $merchant } } }
                }
              }
            }
          ) {
            id
            modifier {
              price
              id
              name
              vat
              store_modifiers(where: { store: { slug: { _eq: $storeSlug } } }) {
                in_stock
              }
            }
          }
        }
      }
    }
  }
`

const QUERY_GET_FIRST_PRODUCT = gql`
  query getProduct($merchant: String!, $storeSlug: String!) {
    products(
      where: {
        merchant: { slug: { _eq: $merchant } }
        slug: { _eq: $slug }
        archived_at: { _is_null: true }
      }
      limit: 1
    ) {
      id
      name
      description
      default_vat
      slug
      type
      default_variant_id
      options
      attributes
      variants: product_variants(
        where: {
          store_variants: {
            published_at: { _is_null: false }
            in_stock: { _eq: true }
          }
        }
      ) {
        default_variant
        id
        name
        sku
        description
        attributes
        options
        image
        price
        published
        restrictions
        limit
        vat
        store_variants(
          where: {
            store: { slug: { _eq: $storeSlug } }
            product_variant: { product: { slug: { _eq: $slug } } }
          }
        ) {
          in_stock
          store_id
          stock_count
          stock_type
          stock_sold
          published_at
          product_variant {
            id
          }
        }
        additionalImages: additional_images {
          id
        }
        source: product {
          slug
          category_id
          category {
            id
            name
            slug
          }
        }
      }
      modifier_group_arrangement
      product_modifiers: product_modifier_groups {
        modifier_group {
          id
          name
          minimum
          minimum_enabled
          maximum
          maximum_enabled
          modifier_arrangement
          modifier_assocs: modifier_group_modifiers(
            where: {
              modifier: {
                store_modifiers: {
                  published_at: { _is_null: false }
                  store: { slug: { _eq: $storeSlug } }
                }
              }
            }
          ) {
            id
            modifier {
              price
              id
              name
              vat
              sku
              store_modifiers(where: { store: { slug: { _eq: $storeSlug } } }) {
                in_stock
              }
            }
          }
        }
      }
    }
  }
`

export {
  QUERY_GET_PRODUCT,
  QUERY_GET_FIRST_PRODUCT,
  QUERY_GET_PREORDER_PRODUCT
}
